import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "items", "input", "count", "template" ]

  itemsTargetConnected(el) {
    el.addEventListener('change', this.#updateCounts)
  }

  prepend(e) {
    e.preventDefault()
    this.insert("afterbegin")
  }

  append(e) {
    e.preventDefault()
    this.insert("beforeend")
  }

  remove(e) {
    e.preventDefault()

    Array.from(this.itemsTarget.children).forEach(el => {
      if (el.contains(e.target)) {
        el.remove()
      }
    })
  }

  insert(where) {
    const content = this.templateTarget.innerHTML
    this.itemsTarget.insertAdjacentHTML(where, content)
  }

  #updateCounts = () => {
    const items = this.inputTargets.filter(el => el.value.trim() != "")
    this.countTargets.forEach(t => { t.textContent = items.length })
  }
}
